import { useEffect } from 'react';

const usePreventPageReload = (shouldPreventReload: boolean) => {
  useEffect(() => {
    if (!shouldPreventReload) return;
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [shouldPreventReload]);
};

export default usePreventPageReload;
